module.exports = __webpack_public_path__ + "epdf-app/dashboard/envelope/waiting/waiting-3Al_0FDB.html";